import { useMemo, useState } from "react";
import { ExternalLink, RefreshCw } from "lucide-react";
import { useI18n } from "../i18n/I18nProvider";
import { PageHeader } from "../components/PageHeader";
import { useAuth } from "../auth/AuthProvider";
import { API_BASE } from "../api/client";

export function PreviewPage() {
  const { t } = useI18n();
  const { session } = useAuth();
  const [reloadKey, setReloadKey] = useState(0);

  // Use API_BASE so the iframe always targets the API origin, not the SPA
  // origin. Without this, in production where the SPA and API live on separate
  // (sub)domains the relative URL resolves to the SPA domain, Nginx serves
  // index.html instead of the preview page, and the iframe renders the React
  // app (home/stats page) instead of the store mockup.
  const url = useMemo(() => {
    if (!session) return null;
    return `${API_BASE}/tenant/preview-page?token=${encodeURIComponent(session.token)}&t=${Date.now() + reloadKey}`;
  }, [session, reloadKey]);

  return (
    <div className="page pv-page is-active" style={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <PageHeader titleKey="preview_title" subtitleKey="preview_subtitle">
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <button
            type="button"
            className="btn-sm btn-ghost"
            onClick={() => setReloadKey((k) => k + 1)}
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <RefreshCw size={13} /> {t("preview_reload")}
          </button>
          {url && (
            <a className="btn-sm btn-ghost" href={url} target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <ExternalLink size={13} /> {t("preview_open_tab")}
            </a>
          )}
        </div>
      </PageHeader>
      {url ? (
        <iframe
          key={reloadKey}
          src={url}
          title="Aperçu widget"
          style={{
            width: "100%",
            flex: 1,
            minHeight: 0,
            border: "none",
            borderRadius: 12,
            background: "#f5f3f0",
          }}
        />
      ) : (
        <div className="card" style={{ padding: 24 }}>
          <p style={{ color: "var(--text-muted)" }}>—</p>
        </div>
      )}
    </div>
  );
}
